/**
 * Offer-letter date checks, UX only (QA a, Prompt #591, T134/T137). The
 * server (sendOfferLetter's checkOfferDates) is the authority and refuses the
 * same cases; this copy only blocks the form before sending. Same basis as
 * the letter: "today" is the calendar date in America/Chicago (the letter's
 * Date line), and the datetime-local values are Central wall-clock times.
 */
const NAIVE_DATE_TIME = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::\d{2}(?:\.\d+)?)?)?$/;

export const OFFER_DATE_MESSAGES = {
  'start-invalid': "The start date isn't a valid date.",
  'start-before-offer-date': "The start date can't be before today's date (the offer letter's date, Central Time).",
  'end-invalid': "The end date isn't a valid date. Leave it empty or use TBD if it isn't known.",
  'end-before-start': "The end date can't be before the start date.",
};

function wallClock(value) {
  const m = NAIVE_DATE_TIME.exec((value || '').trim());
  if (!m) return null;
  const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
  const dt = new Date(Date.UTC(y, mo - 1, d));
  if (dt.getUTCFullYear() !== y || dt.getUTCMonth() !== mo - 1 || dt.getUTCDate() !== d) return null;
  if (m[4] !== undefined && (Number(m[4]) > 23 || Number(m[5]) > 59)) return null;
  const day = `${m[1]}-${m[2]}-${m[3]}`;
  return { day, minute: m[4] !== undefined ? `${day}T${m[4]}:${m[5]}` : null };
}

export function todayCentral(now = new Date()) {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit' }).format(now);
}

/** null when OK, else a key of OFFER_DATE_MESSAGES. An empty end means TBD. */
export function checkOfferDates(startDate, endDate, now = new Date()) {
  const start = wallClock(startDate);
  if (!start) return 'start-invalid';
  if (start.day < todayCentral(now)) return 'start-before-offer-date';
  if (!endDate || endDate === 'TBD') return null;
  const end = wallClock(endDate);
  if (!end) return 'end-invalid';
  const before = start.minute && end.minute ? end.minute < start.minute : end.day < start.day;
  return before ? 'end-before-start' : null;
}
